// extracted by mini-css-extract-plugin
export default {"label":"VersionLabel_label__K3A9Z"};